// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { Button } from "@/components/ui/button";
import { LogIn, Leaf } from "lucide-react";

export default function Login() {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-background">
      <div className="relative hidden md:block grain-overlay">
        <img
          src="https://images.unsplash.com/photo-1545840716-c82e9eec6930?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxhcG90aGVjYXJ5JTIwYm90YW5pY2FsJTIwaGVyYnN8ZW58MHx8fHwxNzg0NzAxNjY0fDA&ixlib=rb-4.1.0&q=85"
          alt="Apothecary"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/40" />
        <div className="absolute bottom-8 left-8 right-8 text-white">
          <div className="flex items-center gap-2 mb-3">
            <Leaf className="w-5 h-5" strokeWidth={1.5} />
            <span className="uppercase tracking-[0.2em] text-xs font-medium">Saint Herb · KhulaTill</span>
          </div>
          <h2 className="font-display text-3xl leading-tight max-w-sm">
            A calm register, for a considered apothecary.
          </h2>
        </div>
      </div>

      <div className="flex items-center justify-center px-8 py-16">
        <div className="w-full max-w-sm">
          <div className="mb-10">
            <div className="inline-flex items-center gap-2 text-primary mb-8">
              <div className="h-9 w-9 rounded-full bg-primary text-primary-foreground grid place-items-center">
                <Leaf className="w-4 h-4" strokeWidth={1.5} />
              </div>
              <span className="font-display text-xl">Saint Herb</span>
            </div>
            <h1 className="font-display text-4xl sm:text-5xl leading-[1.05] mb-3">Sign in</h1>
            <p className="text-muted-foreground text-sm">
              Continue with your Google account. Roles are managed by your store admin.
            </p>
          </div>

          <Button
            data-testid="google-login-btn"
            onClick={handleGoogleLogin}
            className="w-full rounded-full h-12 text-base bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            <LogIn className="w-4 h-4 mr-2" strokeWidth={1.5} /> Continue with Google
          </Button>

          <div className="mt-8 text-xs text-muted-foreground leading-relaxed">
            The first person to sign in becomes the store <span className="font-semibold text-foreground">Admin</span>.
            Subsequent staff join as Cashier until promoted.
          </div>
        </div>
      </div>
    </div>
  );
}
